import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
  Progress,
} from "@chakra-ui/react";

const shareholders = [
  { name: "شرکت گروه م. سرمایه‌گذاری امید (سهامی عام)", percentage: 34.915 },
  {
    name: "مؤسسه صندوق بازنشستگی، وظیفه، ازکارافتادگی و پس‌انداز",
    percentage: 33.144,
  },
  { name: "شرکت معدنی و صنعتی چادرملو (سهامی عام)", percentage: 16.573 },
  { name: "صندوق سرمایه‌گذاری ا.ب. امید ایرانیان (BFM)", percentage: 3.486 },
  { name: "بانک سپه", percentage: 3.257 },
  { name: "مؤسسه رفاه و تأمین آتیه کارکنان بانک سپه", percentage: 2.902 },
  { name: "شرکت سرمایه‌گذاری سپه (سهامی عام)", percentage: 1.985 },
];

export const SectionShareholders = () => {
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const tableBg = useColorModeValue("white", "dark.300");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const thBg = useColorModeValue("gray.50", "dark.200");

  return (
    <Box>
      <Container maxW="container.lg">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              سهامداران و ساختار مالکیت
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              ترکیب سهامداران عمده شرکت
            </Text>
          </VStack>

          <Box
            bg={tableBg}
            borderRadius="xl"
            border="1px solid"
            borderColor={borderColor}
            overflow="hidden"
          >
            <Table size="sm">
              <Thead>
                <Tr bg={thBg}>
                  <Th borderColor={borderColor} py={3} fontSize="xs">
                    سهامدار
                  </Th>
                  <Th borderColor={borderColor} py={3} fontSize="xs" isNumeric>
                    درصد مالکیت
                  </Th>
                  <Th borderColor={borderColor} py={3} fontSize="xs" w="30%">
                    نمودار
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {shareholders.map((s) => (
                  <Tr key={s.name}>
                    <Td borderColor={borderColor} py={3}>
                      <Text fontSize="sm" color={headingColor}>
                        {s.name}
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} py={3} isNumeric>
                      <Text fontSize="sm" fontWeight="bold" color="brand.500">
                        {s.percentage}٪
                      </Text>
                    </Td>
                    <Td borderColor={borderColor} py={3}>
                      <Progress
                        value={s.percentage}
                        size="sm"
                        borderRadius="full"
                        colorScheme="brand"
                      />
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};
